import { identify, Identify } from "@amplitude/analytics-browser";
import { ALL_FLAGS, Flags, TRUE_FLAG } from "../reducers/models/flags";

export function flagIsEnabled(flags: Flags, flag: string) {
  return flags[flag] == TRUE_FLAG;
}

export function userAttributesToFlags(attributes: {
  [key: string]: string | undefined;
}) {
  return JSON.parse(attributes["custom:flags"] || "{}") as Flags;
}

export function combineFlags(
  flagsFromCookies: Flags,
  flagsFromAttributes: Flags,
) {
  return ALL_FLAGS.reduce((flagsAccumulator, flag) => {
    const flagFromAttribute = flagsFromAttributes[flag];
    if (flagFromAttribute === undefined) {
      const flagFromCookie = flagsFromCookies[flag];
      if (flagFromCookie !== undefined) {
        flagsAccumulator[flag] = flagFromCookie;
      }
    } else {
      flagsAccumulator[flag] = flagFromAttribute;
    }
    return flagsAccumulator;
  }, {} as Flags);
}

export function trackFlags(flags: Flags) {
  Object.keys(flags).forEach((flag) => {
    const identifyObj = new Identify();
    identifyObj.set(flag, flags[flag] || "");
    identify(identifyObj);
  });
}
